import Vue from "vue";
import { DropDownButtonPlugin } from "@syncfusion/ej2-vue-splitbuttons";
Vue.use(DropDownButtonPlugin);
export default Vue.extend({
    props: {
        id: {
            type: String,
            required: true
        },
        items: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            buttonElement: null
        };
    },
    methods: {
        onSelect(args) {
            this.$emit("select", args.item.id);
        }
    },
    mounted() {
        this.buttonElement = this.$refs.exportMenuButton
            .$el;
    },
    destroyed() {
        // The button is no longer inside this component: remove it from the toolbar,
        // otherwise the grid moves it to the page body when its toolbar is destroyed
        this.buttonElement?.remove();
    }
});
